// extracted by mini-css-extract-plugin
export default {"header":"Header_header__6GZhQ","main-image":"Header_main-image__xyC9E"};